import { clone, cleanClone } from './clone';
export { handeOrderBtnClick, handleLisaTeenusBtnClick, handleLogedOut, handlePrivatePerson, handleGoldUser, handleLoggedIn };

function handeOrderBtnClick(event) {
	var currentEventTarget = event.currentTarget.classList;
	clone(currentEventTarget);
	return false;
}

function handleLisaTeenusBtnClick(event) {
	var currentEventTarget = event.currentTarget.classList;
	var currentEventDataset = event.currentTarget.dataset;
	clone(currentEventTarget, currentEventDataset);
	return false;
}

function handleLogedOut() {
	sessionStorage.setItem('loggedIn', false);
	sessionStorage.setItem('link', window.location.href);
	sessionStorage.setItem('setupTime', new Date().getTime());
	console.log(sessionStorage);
}

function handlePrivatePerson() {

	if (document.querySelector('a[data-service="lisatookoht"')) {
		var privatePerson = document.querySelector("body");
		var tookohtWrapper = document.querySelector(".lisa-tookoht-wrapper");
		var tookohtBtn = document.querySelector('a[data-service="lisatookoht"');
		if (tookohtWrapper || tookohtBtn) {
			if (privatePerson.classList.contains("private")) {
				tookohtWrapper.classList.add("locked");
				tookohtBtn.classList.add("locked");
			}
		}
	}

}

function handleGoldUser() {
	if (document.querySelector("body")) {
		var goldUser = document.querySelector("body");
		var ukoBtn = document.querySelector('a[data-service="uko"');
		if (ukoBtn) {
			if (goldUser.classList.contains("packet-gold")) {
				ukoBtn.classList.add("locked");
				document.querySelector(".uko-akteveerimine-price").innerHTML = 0.00;
				document.querySelector(".uko").classList.add("locked");
				document.querySelector("#uko-akteveerimine").checked = true;
				document.querySelector("#uko-akteveerimine").classList.add("locked");
			}
		}

	}

}

function handleLoggedIn() {
	var isLoggedin = sessionStorage.getItem("loggedIn");
	console.log(sessionStorage);
	console.log(isLoggedin);

	if (isLoggedin) {
		var hours = 24; // Reset when storage is more than 24hours

		var now = new Date().getTime();
		var setupTime = parseFloat(sessionStorage.getItem('setupTime'));
		console.log(now, setupTime);

		if (now - setupTime > hours * 60 * 60 * 1000) {
			sessionStorage.clear();
		} else {
			var eventFire = function eventFire(el, etype) {
				if (el.fireEvent) {
					el.fireEvent('on' + etype);
				} else {
					var evObj = document.createEvent('Events');
					evObj.initEvent(etype, true, false);
					el.dispatchEvent(evObj);
				}
			};

			var usedTrial = function usedTrial() {
				cleanClone();
				var newContent = document.createElement("h2");
				newContent.innerHTML = "See pakett on juba kasutatud";
				document.querySelector(".cleanModal").appendChild(newContent);
			};

			var lastService = sessionStorage.getItem("service");
			var link = sessionStorage.getItem("link");
			console.log(lastService);

			if (lastService === 'bronze') {
				eventFire(document.querySelector('.bronze-btn'), 'click');
				sessionStorage.clear();
			} else if (lastService === 'silver') {
				eventFire(document.querySelector('.silver-btn'), 'click');
				sessionStorage.clear();
			} else if (lastService === 'gold') {
				eventFire(document.querySelector('.gold-btn'), 'click');
				sessionStorage.clear();
			} else if (lastService === 'bronze-tasuta') {
				if (USER_ID > 0) {
					var freeBtn = document.querySelector('a[data-link="/?f=kaardirakendus&try-free=bronze"');
					console.log(freeBtn);

					if (freeBtn) {
						var _link = freeBtn.dataset.link;
						$("#prooviTasutaModal").show();
						document.querySelector(".alusta").setAttribute('href', _link);
						sessionStorage.clear();
					} else {
						usedTrial();
					}
				}
			} else if (lastService === 'silver-tasuta') {
				if (USER_ID > 0) {
					var _freeBtn = document.querySelector('a[data-link="/?f=kaardirakendus&try-free=silver"');

					console.log(_freeBtn);

					if (_freeBtn) {
						var _link2 = _freeBtn.dataset.link;
						$("#prooviTasutaModal").show();
						document.querySelector(".alusta").setAttribute('href', _link2);
						sessionStorage.clear();
					} else {
						usedTrial();
					}
				}
			} else if (lastService === 'gold-tasuta') {
				if (USER_ID > 0) {
					var _freeBtn2 = document.querySelector('a[data-link="/?f=kaardirakendus&try-free=gold"');

					if (_freeBtn2) {
						var _link3 = _freeBtn2.dataset.link;
						$("#prooviTasutaModal").show();
						document.querySelector(".alusta").setAttribute('href', _link3);
						sessionStorage.clear();
					} else {
						usedTrial();
					}
				}
			} else {
				if (lastService === "lisatookoht") {
					var privatePerson = document.querySelector("body");

					if (privatePerson) {
						eventFire(document.querySelector('a[data-service="lisatookoht"'), 'click');
						var mainOrder = document.querySelector(".mainOrder");
						var orderModal = document.querySelector(".orderModal");
						orderModal.removeChild(mainOrder);
						var mainOrder2 = document.createElement("h2");
						mainOrder2.classList.add('title');
						mainOrder2.innerHTML = "Lisatöökohtade funktsionaalsus on kättesaadav vaid ettevõtte kontole";
						orderModal.appendChild(mainOrder2);
					} else {
						eventFire(document.querySelector('a[data-service="lisatookoht"'), 'click');
						sessionStorage.clear();
					}

					sessionStorage.clear();
				} else if (lastService === "uko") {
					eventFire(document.querySelector('a[data-service="uko"]'), 'click');
					sessionStorage.clear();
				} else if (lastService === "soil") {
					eventFire(document.querySelector('a[data-service="soil"]'), 'click');
					sessionStorage.clear();
				} else if (lastService === "restrictions") {
					eventFire(document.querySelector('a[data-service="restrictions"]'), 'click');
					sessionStorage.clear();
				} else if (lastService === "provisions") {
					eventFire(document.querySelector('a[data-service="provisions"]'), 'click');
					sessionStorage.clear();
				} else if (lastService === "manuaalne-eagent") {
					eventFire(document.querySelector('a[data-service="manuaalne-eagent"'), 'click');
					sessionStorage.clear();
				} else {
					sessionStorage.clear();
				}
			}
		}
	} else {
		sessionStorage.clear();
	}
}